// EmailHistory.jsx
import React, { useState, useEffect } from 'react';
import { __ } from './translations';

const EmailHistory = ({ companyId }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const response = await fetch(
                    `${boardMemberData.restURL}board-member/v1/companies/${companyId}/email-history`,
                    {
                        headers: {
                            'X-WP-Nonce': boardMemberData.nonce
                        }
                    }
                );
                
                if (!response.ok) {
                    throw new Error('Failed to fetch email history');
                }
                
                const data = await response.json();
                setHistory(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        
        fetchHistory();
    }, [companyId]);
    
    if (loading) {
        return <p>{__('Loading...')}</p>;
    }
    
    if (error) {
        return <p className="text-red-500">{error}</p>;
    }
    
    if (!history.length) {
        return <p>{__('No email history found.')}</p>;
    }
    
    const getEmailTypeName = (type) => {
        switch (type) {
            case 'welcome': return __('Welcome Email');
            case 'contribution_acceptance': return __('Contribution Acceptance');
            case 'contribution_regenerate': return __('Contribution Email Resent');
            case 'bulk_contribution': return __('Bulk Contribution');
            case 'nip_reminder': return __('NIP Reminder');
            case 'contribution_reminder': return __('Contribution Reminder');
            default: return type;
        }
    };
    
    return (
        <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 border-b border-gray-200 sm:px-6">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                    {__('Email Communication History')}
                </h3>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {__('Date')}
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {__('Type')}
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {__('Recipient')}
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {__('Status')}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {history.map((event, index) => (
                            <tr key={index}>
                                <td className="px-6 py-4  text-sm text-gray-500">
                                    {new Date(event.timestamp).toLocaleString()}
                                </td>
                                <td className="px-6 py-4  text-sm text-gray-500">
                                    {getEmailTypeName(event.type)}
                                </td>
                                <td className="px-6 py-4  text-sm text-gray-500">
                                    {event.recipient}
                                </td>
                                <td className="px-6 py-4  text-sm">
                                    {event.success ? (
                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                            {__('Sent')}
                                        </span>
                                    ) : (
                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                                            {__('Failed')}
                                        </span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmailHistory;